<div class="row mb-2 mb-xl-3">
  <div class="col-auto d-none d-sm-block">
    <h3>{{ title }}</h3>
  </div>

  <div class="col-auto ms-auto text-end mt-n1">
    <ng-content select="[right]" />
  </div>
</div>
